React = require 'react'
FormFields = require './internal/form-fields'
t = require('app/scripts/views/internal/recup-with-helpers')('credit_card')
{ formatMoney } = require 'app/scripts/lib/format/money'
localizeCount = require 'app/scripts/lib/localize-count'
OrgFeatures = require('@trello/product-features').OrganizationFeatures
{ PurchaseFormIds } = require '@trello/webdriverio-tests'

module.exports = class extends React.Component
  displayName: 'SummaryComponent'

  formFields: []
  requiredFields: []

  constructor: (props) ->
    super(props)

  render: t.renderable ->
    {
      monthlyProduct,
      yearlyProduct,
      billingStrategy,
      selectedBillingPlan,
      subTotalCost,
      tax,
      region,
      invitedUsersCount,
      invitedUsersSubTotal,
      hasPromo,
      discountPercentage,
      promocode,
      onChangePromoCode
    } = @props

    billableCollaboratorCount = billingStrategy.billableCollaboratorCount || 0
    licenseCount = billingStrategy.userCount
    isYearly = selectedBillingPlan.toString() == yearlyProduct.productNumber.toString()
    licenseQuantityCopy = if isYearly then 'yearly-licenses' else 'monthly-licenses'
    totalPlusTax = (parseFloat(subTotalCost) + parseFloat(tax || 0)).toFixed(2)

    hasBCPromo = promocode?.split('-')[0] == 'BC'
    isPromoYearly = hasBCPromo && promocode?.split('-')[1] == 'A'
    promoDoesApply = hasBCPromo && (isYearly == isPromoYearly)
    discountAmount = if hasBCPromo then subTotalCost * discountPercentage / 100 else null

    showBillableCollaborators = (
      billableCollaboratorCount > 0 &&
      OrgFeatures.isFeatureEnabled 'multiBoardGuests', selectedBillingPlan
    )

    if showBillableCollaborators
      licenseCount += billableCollaboratorCount

    render = =>
      t.div '.billing-summary', =>
        if hasPromo
          t.label { htmlFor: 'promocode-input' }, ->
            t.format 'promo-code'
          t.input {
            className: 'billing-summary-slack-promocode-input',
            id: 'promocode-input',
            type: 'text',
            placeholder: t.l('add-code'),
            autoComplete: 'off',
            value: promocode,
            onChange: onChangePromoCode
          }
        t.h3 ->
          t.format 'billing-plan-summary'
        t.table ->
          t.tbody ->
            t.tr ->
              t.td 'data-test-id': PurchaseFormIds.PurchaseFormSummaryLicense, ->
                t.span '.licences-quantity', ->
                  if billingStrategy.flatRate
                    t.format 'one-trello-gold-license'
                  else
                    t.text localizeCount licenseQuantityCopy, licenseCount
                if showBillableCollaborators
                  memberCount = localizeCount 'team-members', billingStrategy.userCount
                  mbgCount = localizeCount 'multi-board-guests', billableCollaboratorCount
                  t.div '.small.multi-board-guest-line-item', ->
                    t.format 'multi-board-guest-line-item', { memberCount, mbgCount }
                if not hasBCPromo
                  if isYearly
                    t.span '.save-info.small', ->
                      t.format 'monthly-saving-info',
                      savePercent: yearlyProduct.savePercent
                  else
                    t.span '.switch-to-annual.small', ->
                      t.format 'annual-saving-info',
                        savePercent: yearlyProduct.savePercent
              t.td 'data-test-id': PurchaseFormIds.PurchaseFormSummarySubtotal, ->
                if invitedUsersCount
                  t.strong '.cost-each-monthly.price', ->
                    t.format 'amount-usd', amount: formatMoney subTotalCost
                else
                  t.strong '.cost-each-monthly.price', ->
                    t.format 'amount-usd', amount: formatMoney (if isYearly then yearlyProduct.price else monthlyProduct.monthlyPrice)
                  if !billingStrategy.flatRate
                    t.span '.small', ->
                      t.format 'each'
            if invitedUsersCount
              t.tr '.invited-users-billing-summary', ->
                t.td ->
                  t.span '.licences-quantity', ->
                    t.text invitedUsersCount
                    t.text ' Pending Invitations'
                t.td ->
                  t.strong '.cost-each-monthly.price', ->
                    t.format 'amount-usd', amount: formatMoney invitedUsersSubTotal
              t.tr '.invited-users-billing-description', ->
                t.td { colSpan: '2' }, ->
                  t.span '.small', ->
                    t.text "You'll be billed "
                    t.format 'amount-usd', amount: formatMoney (if isYearly then yearlyProduct.price else monthlyProduct.monthlyPrice)
                    t.text ' immediately for each team member that accepts your invitation.'
            if promoDoesApply
              t.tr ->
                t.td ->
                  t.text "Discount"
                t.td ->
                  t.text "-"
                  t.strong ->
                    t.format 'amount-usd', amount: formatMoney discountAmount
            t.tr ->
              t.td 'data-test-id': PurchaseFormIds.PurchaseFormSummaryTaxRegion, ->
                if region != null
                  t.format 'sales-tax',
                    region: (if tax then region else '')
                else
                  t.span '.u-form-error', 'data-test-id': PurchaseFormIds.PurchaseFormSummaryTaxError, ->
                    t.format 'could-not-calculate-sales-tax'
              t.td 'data-test-id': PurchaseFormIds.PurchaseFormSummaryTaxAmount, ->
                if tax != null
                  t.strong ->
                    t.format 'amount-usd', amount: formatMoney tax

          t.tfoot ->
            t.tr ->
              t.td ->
                t.format 'total-label'
              t.td 'data-test-id': PurchaseFormIds.PurchaseFormSummaryTotal, ->
                t.strong '.price', ->
                  t.format 'amount-usd', amount: formatMoney totalPlusTax

    t.tag FormFields, {
      @formFields
      @requiredFields
      initialState: {}
      ref: (formFieldsRef) => @formFieldsRef = formFieldsRef
      render
    }
